import { JobPostingLocationType } from "@/gql/graphql"

type GenerateJobTitleArgs = {
  position?: string | null
  locationType?: JobPostingLocationType | null
  creativeWorkType?: {
    indefiniteArticle: string
    name: string
  } | null
  locationName?: string | null
  startDate?: Date | null
  endDate?: Date | null
}

export const generateJobTitle = ({
  position,
  locationType = JobPostingLocationType.Telecommute,
  creativeWorkType,
  locationName,
  startDate,
  endDate,
}: GenerateJobTitleArgs): string => {
  const formatDate = (date: Date | null | undefined): string => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return "" // Ensures a valid Date object
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  const formattedStartDate = formatDate(startDate)
  const formattedEndDate = formatDate(endDate)
  const showSingleDate = (startDate && !endDate) || (formattedStartDate === formattedEndDate && formattedStartDate)
  const showDateRange = formattedStartDate && formattedEndDate

  let title = position ? `${position} needed` : "Someone needed"

  if (creativeWorkType && creativeWorkType.name !== "") {
    title += ` for ${
      creativeWorkType.indefiniteArticle ? `${creativeWorkType.indefiniteArticle} ` : ""
    }${creativeWorkType.name}`
  }

  // Location logic
  if (locationType !== JobPostingLocationType.Telecommute && locationName) {
    title += ` in ${locationName}`
  } else if (!locationType || locationType === JobPostingLocationType.Telecommute) {
    title += " remotely"
  }
  // Date logic
  if (showSingleDate) {
    title += ` starting ${formattedStartDate}`
  } else if (showDateRange) {
    title += ` from ${formattedStartDate} - ${formattedEndDate}`
  }

  return title
}
